import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader'

/**
 * Base
 */
// Debug
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)

/**
 * Environment Map
 */

const rgbeLoader = new RGBELoader()

rgbeLoader.load('./textures/environmentMap/2k.pic', (environmentMap) => {
    environmentMap.mapping = THREE.EquirectangularReflectionMapping

    
    scene.background = environmentMap
    scene.environment = environmentMap
})

console.log(rgbeLoader)
/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load("/textures/matcaps/8.png")
matcapTexture.colorSpace = THREE.SRGBColorSpace


/**
 * Fonts
 */

const fontLoader = new FontLoader()


fontLoader.load('fonts/helvetiker_regular.typeface.json', (font) => {
    const header = new TextGeometry(
        'Aldo Portillo',
        {
            font: font,
            size: 0.5,
            height: 0.2,
            curveSegments: 5, //Controls triangles around curves
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.02,
            bevelOffset: 0,
            bevelSegments: 4, //controls triangles between edges
        }
    )

    const subHeader = new TextGeometry(
        'Portfolio 3.0 Coming Soon',
        {
            font: font,
            size: 0.2,
            height: 0.2,
            curveSegments: 5, //Controls triangles around curves
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.02,
            bevelOffset: 0,
            bevelSegments: 4, //controls triangles between edges
        }
    )

    subHeader.computeBoundingBox()
    //console.log(subHeader.boundingBox)
    subHeader.translate(
        - (subHeader.boundingBox.max.x - 0.02) * 0.5, // Subtract bevel size
        - (subHeader.boundingBox.max.y - 0.02) * 0.5 - 0.5, // Subtract bevel size
        - (subHeader.boundingBox.max.z - 0.03) * 0.5  // Subtract bevel thickness

    )

    header.center()
    const material = new THREE.MeshMatcapMaterial()
    material.matcap = matcapTexture
    const text = new THREE.Mesh(header, material)
    const subText = new THREE.Mesh(subHeader, material)
    scene.add(subText)
    scene.add(text)

    const donutGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45)

    for(let i = 0; i < 100; i++) {

        const donut = new THREE.Mesh(donutGeometry, material)
        
        //Add randomness

        donut.position.x = (Math.random() - 0.5) * 10
        donut.position.y = (Math.random() - 0.5) * 10
        donut.position.z = (Math.random() - 0.5) * 10

        donut.rotation.x = Math.random() * Math.PI
        donut.rotation.y = Math.random() * Math.PI

        const scale = Math.random()
        donut.scale.set(scale, scale, scale)
        scene.add(donut)
    } 

})

/**
 * Object
 */
// const cube = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1),
//     new THREE.MeshBasicMaterial()
// )

// scene.add(cube)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 5
scene.add(camera)

// gui.add(camera.position, "x").min(-10).max(10).step(0.01)
// gui.add(camera.position, "y").min(-10).max(10).step(0.01)
// gui.add(camera.position, "z").min(-10).max(10).step(0.01)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // camera.rotation.x = 0.5 * Math.PI * elapsedTime;
    // camera.rotation.y = 0.5 * Math.PI * elapsedTime;

    camera.position.x = Math.cos(elapsedTime)
    camera.position.y = Math.sin(elapsedTime)

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()